import * as React from "react";
import type { Editor } from "@tiptap/react";

export function useIsNodeActive(
    editor: Editor | null | undefined,
    name: string,
    attrs?: Record<string, any>
) {
    const [active, setActive] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (!editor) return;

        const compute = () => setActive(editor.isActive(name, attrs));

        // calcula já no mount
        compute();

        // reaja a mudanças de seleção/estado
        editor.on("selectionUpdate", compute);
        editor.on("update", compute);
        editor.on("transaction", compute);
        editor.on("focus", compute);
        editor.on("blur", compute);

        return () => {
            editor.off("selectionUpdate", compute);
            editor.off("update", compute);
            editor.off("transaction", compute);
            editor.off("focus", compute);
            editor.off("blur", compute);
        };
    }, [editor, name, JSON.stringify(attrs)]);

    return active;
}
